import { useCallback } from 'react'

import { useOperationsSoundPreference } from './useOperationsSoundPreference'

export const useNotificationSoundControl = () => {
  const [soundEnabled, setSoundEnabled] = useOperationsSoundPreference()
  const toggleSound = useCallback(() => {
    setSoundEnabled((prev) => !prev)
  }, [setSoundEnabled])
  return { soundEnabled, toggleSound }
}
